import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../utils/rel';
import { getChenZhan } from '../../../../../services/api';
import Title from '../../../components/title';
import SubTitle from '../../../components/subtitle';
import PropTypes from 'prop-types';

class ViewPoints extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };
    state = {
        chenZhanData: [],
    };

    async componentDidMount() {
        try {
            let chenZhanData = await getChenZhan();

            if (chenZhanData.length > 4) {
                chenZhanData = chenZhanData.slice(0, 4);
            }

            this.setState({
                chenZhanData,
            });
        } catch (e) {
            console.error(e);
        }
    }

    render() {
        const { personView, dujiaView } = this.props.content;
        const { chenZhanData } = this.state;

        return (
            <div className={styles.view_points}>
                <Title content="观点" />
                <div className={styles.person_view}>
                    <div className={styles.person_title}>
                        <SubTitle content={{ title: '人物访谈' }} />
                    </div>
                    <ul>
                        {personView.map((item, index) => (
                            <li key={index}>
                                <a href={item.url} rel={rel} target="_blank">
                                    <img src={item.thumbnails} alt={item.title} />
                                    <p>{item.title}</p>
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className={styles.view_right}>
                    <div className={styles.dujia_view}>
                        <div className={styles.dujia_title}>
                            <SubTitle content={{ title: '独家策划' }} />
                        </div>
                        <ul>
                            {dujiaView.map((item, index) => (
                                <li key={index}>
                                    <a href={item.url} rel={rel} target="_blank">
                                        <img src={item.thumbnails} alt={item.title} />
                                        <p>{item.title}</p>
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className={styles.chenzhan_view}>
                        <div className={styles.chenzhan_title}>
                            <SubTitle content={{ title: '热门专题' }} />
                        </div>
                        <ul>
                            {chenZhanData.map((item, index) => (
                                <li key={index}>
                                    <a href={item.url} rel={rel} target="_blank">
                                        <img src={item.image} alt={item.name} />
                                         <p>{item.name}</p>
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(ViewPoints);
